import facebook from '../images/icons/facebook.svg';
import twiter from '../images/icons/twiter.svg';
import instagram from '../images/icons/instagram.svg';
import youtube from '../images/icons/youtube.svg';
import email from '../images/icons/email.svg';
import wifi from '../images/icons/wifi.svg';
import telegram from '../images/icons/telegram.svg';
import pIcon from '../images/icons/p.svg';
import monkey from '../images/icons/monkey.svg';
import heart from '../images/icons/heart.svg';
import facebook_F from '../images/icons/facebook-f.svg';
import twitter_1 from '../images/icons/twitter1.svg';

import facebookGreen from '../images/icons/facebook-green.svg';
import twiterGreen from '../images/icons/twiter-green.svg';
import instagramGreen from '../images/icons/instagram-green.svg';
import youtubeGreen from '../images/icons/youtube-green.svg';
import emailGreen from '../images/icons/email-green.svg';
import wifiGreen from '../images/icons/wifi-green.svg';

import phoneIcon from '../images/icons/phone.svg';
import cupIcon from '../images/icons/cup.svg';
import androidIcon from '../images/icons/android.svg';
import appleIcon from '../images/icons/apple.svg';

export const iconsMenu = [phoneIcon, cupIcon, androidIcon, appleIcon];

export const socialMediaIcons = [
  facebook,
  twiter,
  instagram,
  youtube,
  email,
  wifi,
];

export const socialMediaIconsLight = [
  facebookGreen,
  twiterGreen,
  instagramGreen,
  youtubeGreen,
  emailGreen,
  wifiGreen,
];

export const asideLinks = [
  facebook_F,
  twitter_1,
  telegram,
  pIcon,
  monkey,
  heart,
];
